import CONSTANT from 'modules/constant'
import type {
  NotificationProps,
  NotificationCountProps,
  PaginationProps,
  UpdateNotificationProps,
  ResultProps
} from 'modules/types'
import { API, headers } from './api'

const InboxAPI = API.injectEndpoints({
  endpoints: (builder) => ({
    getInboxList: builder.query<
      PaginationProps<NotificationProps>,
      { start: number; length: number }
    >({
      query: (payload) => {
        const body = new FormData()
        body.append('start', payload.start.toString())
        body.append('length', payload.length.toString())
        body.append('columns[0][orderable]', 'true')
        body.append('columns[0][name]', 'id')
        body.append('order[0][column]', '1')
        body.append('order[0][dir]', 'desc')

        console.log({ start: body.get('start'), length: body.get('length') })

        return {
          url: CONSTANT.URL_INBOX_LIST,
          method: 'POST',
          headers: headers({ useContentType: false }),
          body: body,
          formData: true
        }
      },
      providesTags: ['InboxList']
    }),
    getInboxDetail: builder.query<NotificationProps[], string | number>({
      query: (id) => ({
        url: CONSTANT.URL_INBOX_DETAIL.replace('{id}', id.toString()),
        method: 'GET',
        headers: headers()
      })
    }),
    getInboxCount: builder.query<NotificationCountProps, void>({
      query: () => ({
        url: CONSTANT.URL_INBOX_COUNT,
        method: 'GET',
        headers: headers()
      }),
      providesTags: ['InboxCount']
    }),
    updateNotification: builder.mutation<ResultProps, UpdateNotificationProps>({
      query: (payload) => ({
        url: CONSTANT.URL_UPDATE_NOTIF,
        method: 'POST',
        headers: headers(),
        body: JSON.stringify(payload)
      }),
      invalidatesTags: ['InboxList', 'InboxCount']
    }),
    updateAllNotifications: builder.mutation<ResultProps, void>({
      query: () => ({
        url: CONSTANT.URL_UPDATE_READ_ALL_NOTIF,
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({})
      }),
      invalidatesTags: ['InboxList', 'InboxCount']
    })
  })
})

export const {
  useGetInboxDetailQuery,
  useGetInboxListQuery,
  useGetInboxCountQuery,
  useUpdateNotificationMutation,
  useUpdateAllNotificationsMutation
} = InboxAPI
